import { SvgProps } from 'icons/svg/svg';

export function Timer({ size }: SvgProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6 0C4.81331 0 3.65328 0.351894 2.66658 1.01118C1.67989 1.67047 0.910851 2.60754 0.456725 3.7039C0.00259972 4.80026 -0.11622 6.00665 0.115291 7.17054C0.346802 8.33443 0.918247 9.40352 1.75736 10.2426C2.59648 11.0818 3.66557 11.6532 4.82946 11.8847C5.99335 12.1162 7.19975 11.9974 8.2961 11.5433C9.39246 11.0891 10.3295 10.3201 10.9888 9.33342C11.6481 8.34673 12 7.18669 12 6C12 4.4087 11.3679 2.88258 10.2426 1.75736C9.11742 0.632141 7.5913 0 6 0ZM8.6 8.61C8.55553 8.65888 8.50181 8.69846 8.44196 8.72645C8.3821 8.75445 8.31728 8.7703 8.25126 8.77308C8.18524 8.77588 8.11931 8.76555 8.05731 8.74271C7.9953 8.71986 7.93843 8.68495 7.89 8.64L5.39 6.37C5.34272 6.32109 5.30592 6.26305 5.28185 6.19943C5.25778 6.13581 5.24694 6.06795 5.25 6V3.25C5.25 3.11739 5.30268 2.99021 5.39645 2.89645C5.49022 2.80268 5.61739 2.75 5.75 2.75C5.88261 2.75 6.00979 2.80268 6.10355 2.89645C6.19732 2.99021 6.25 3.11739 6.25 3.25V5.78L8.565 7.905C8.66292 7.99397 8.72159 8.11812 8.72815 8.25027C8.73471 8.38241 8.68863 8.51177 8.6 8.61Z'
        fill='black'
      />
    </svg>
  );
}
